export const SET_TAKEAWAY_RESTAURANTS = 'SET_TAKEAWAY_RESTAURANTS'
export const SET_TAKEAWAY_RESTAURANTS_TOTAL_LENGTH = 'SET_TAKEAWAY_RESTAURANTS_TOTAL_LENGTH'
export const SET_TAKEAWAY_RESTAURANT = 'SET_TAKEAWAY_RESTAURANT'
export const APPEND_TAKEAWAY_RESTAURANTS = 'APPEND_TAKEAWAY_RESTAURANTS'
export const UPDATE_TAKEAWAY_RESTAURANTS = 'UPDATE_TAKEAWAY_RESTAURANTS'
export const ADD_TAKEAWAY_REFRESHING_RESTAURANT_ID = 'ADD_TAKEAWAY_REFRESHING_RESTAURANT_ID'
export const REMOVE_TAKEAWAY_REFRESHING_RESTAURANT_ID = 'REMOVE_TAKEAWAY_REFRESHING_RESTAURANT_ID'
export const SET_TAKEAWAY_SHOW_CREATE_RESTAURANT_ERROR_MODAL = 'SET_TAKEAWAY_SHOW_CREATE_RESTAURANT_ERROR_MODAL'
export const SET_TAKEAWAY_SHOW_LOGIN_FAILED_MODAL = 'SET_TAKEAWAY_SHOW_LOGIN_FAILED_MODAL'
export const SET_TAKEAWAY_RESTAURANT_IS_NOT_VALID = 'SET_TAKEAWAY_RESTAURANT_IS_NOT_VALID'
